import { NonEmpty } from '@aigc/components';
import { Tag } from 'antd';
import type { VideoTaskDto } from '../../task/model';
import { useCalcVideoCost } from '../hook';

export const VideoCredit = (props: { task: VideoTaskDto }) => {
  const calcCost = useCalcVideoCost();

  return (
    <NonEmpty
      value={calcCost(props.task)}
      render={(v) => <Tag variant="outlined">{v} 信用点</Tag>}
    ></NonEmpty>
  );
};
